import { render } from "./chatCompletionsModel.vue?vue&type=template&id=9b4d967a&scoped=true"
import script from "./chatCompletionsModel.vue?vue&type=script&lang=js"
export * from "./chatCompletionsModel.vue?vue&type=script&lang=js"

import "./chatCompletionsModel.vue?vue&type=style&index=0&id=9b4d967a&scoped=true&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4d967a"]])

export default __exports__